require('/vendor/inputmask/inputmask.min')
window.toastr = require('/vendor/toastr/toastr.min')